import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {Col, Row} from 'react-bootstrap';
import Configuration from "../../../../../../config";
import './PaymentForm.scss';

const PaymentForm = ({status}) => {
  const {t, i18n} = useTranslation();
  const url = Configuration.get('REACT_APP_GCAP_PUBLIC_HOST') || 'https://www.gruppocap.it';
  useEffect(() => {
    status ? window.dataLayer.push({"event": "attivazione_analisi_acqua_OK"}) : window.dataLayer.push({"event": "attivazione_analisi_acqua_KO"})
  },[status]);
  return <div className="PaymentForm" data-testid="PaymentForm">
    <Row>
      <Col>
        <h2
          className={'case-step-title'}>{status ? t('cases.analisi_acqua.titles.post_form') : t('cases.analisi_acqua.titles.post_form_not_completed')}</h2>
        <Row className="content">
          <Col>
            <i className="gc-icon-functional-send-2-col">
              <span className="path1"/>
              <span className="path2"/>
            </i>
            {status ? <p>{t("cases.analisi_acqua.payment.credit_card.success")}</p> :
              <p>{t("cases.analisi_acqua.payment.credit_card.failure")}</p>}
          </Col>
        </Row>
      </Col>
    </Row>
    <Row>
      <Col>
        <div className={'action-buttons'}>
          <a href={i18n.language === "it-IT" ?
            `${url}/it/cosa-facciamo/acqua-sicura/controlla-lacqua-di-casa-tua` :
            `${url}/en/what-we-do/safe-water/analyze-the-water-in-your-home`}
             className={"btn btn-primary"}>{t("common.close")}</a>
        </div>
      </Col>
    </Row>

  </div>
};


export default PaymentForm;
